<template>
  <div class="home">

    <!--标题搜索-->
    <div class="module-head-search">
      <div class="moduletitle">成为Gfast开发者，共同分享插件市场</div>
      <div class="moduledesc">您提供的插件必须是基于Gfast框架开发的应用插件！</div>
      <div class="modulesearch">
        <div class="search-wrapper">
          <div class="home-input-wrapper">
            <el-input class="home-search-input"
                      v-model="query.pluginName"
                      placeholder="填写你要搜索的插件"
                      clearable
                      prefix-icon="el-icon-search"
                      @input="handleInputSearch">
            </el-input>
          </div>
          <div class="module-btn" @click="handleInputSearch">搜索</div>
        </div>
      </div>
    </div>
    <div class="clr"></div>
    <!--选项-->
    <div class="module-box">
      <div class="module-item">
        <ul>
          <li class="module-bott"> <span>功能：</span>
            <p>
              <a :class="['search-head', {active: query.pluginCateId == ''}]"
                 @click.prevent="searchList({pluginCateId : ''})">全部</a>
              <a v-for="item in plugincate"
                 :key="item.cateId"
                 @click.prevent="searchList({pluginCateId : item.cateId +''})"
                 :class="['search-head', {active: query.pluginCateId == item.cateId +''}]">{{item.cateName}}</a>
            </p>
          </li>
          <li> <span>价格：</span>
            <p>
              <a :class="['search-head', {active: query.priceType == ''}]"
                 @click.prevent="searchList({priceType : ''})">全部</a>
              <a :class="['search-head', {active: query.priceType == '1'}]"
                 @click.prevent="searchList({priceType : '1'})">免费</a>
              <a :class="['search-head', {active: query.priceType == '2'}]"
                 @click.prevent="searchList({priceType : '2'})">付费</a>
            </p>
            <label>
              <input type="checkbox"
                     name="isOfficial"
                     value="1"
                     @click="isOfficial">
              <font> 官方应用</font>
            </label>
          </li>
        </ul>
      </div>

      <div class="module-list">
        <ul>
          <li v-for="(item, index) in list"
              :key="index">
            <div class="mcard"
                 @click="jump(item)">
              <a><img :src="item.pluginThumb || imgUrl300x200" /></a>
              <p class="mtitle">{{item.pluginName}}</p>
              <p v-if="item.pluginDiscount!==100" class="price"><span class="yp">原价：{{item.pluginPrice | fenToYuan}}</span>&nbsp;<span>{{fenToYuanDiscount(item.pluginPrice,item.pluginDiscount)}}</span></p>
              <p v-else class="price">{{item.pluginPrice | fenToYuan}}</p>
              <P class="update">{{item.created_at}}</P>
              <P class="download">下载：{{item.downloadTimes || 0}}次</P>
            </div>
          </li>
        </ul>
        <div>
          <div class="module-more" v-if="loading">
            <span>正在加载...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinImgUrl from '@/utils/mixin/imgUrl.js'
import { list as listReq, getPlugincate } from '@/api/plugin'
import { fenToYuanDiscount } from '../utils/common'
import _ from 'lodash'
export default {
  name: 'Home',
  mixins: [mixinImgUrl],
  data () {
    return {
      query: {
        pageSize: 16,
        pageNum: 1,
        pluginCateId: '',
        priceType: '', // '' - 全部 '1' - 免费 '2' - 付费
        pluginName: ''
      },
      list: [],
      total: 0,
      plugincate: [],
      loading: false,
      noMore: false,
      scrollTop: 0 // 保存滚动位置
    }
  },
  created () {
    // console.log(this.$route)
    const searchKey = this.$route.query.searchKey
    if (searchKey && searchKey !== '') {
      this.query.pluginName = searchKey
    }
    this.getList()
    this.getPlugincate().then(data => {
      this.plugincate = data
    })

    // 防抖搜索
    this.debouncedSearch = _.debounce(() => {
      this.searchList({ pluginName: this.query.pluginName })
    }, 500)

    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll)
  },
  activated () {
    // 组件激活时恢复滚动位置
    this.$nextTick(() => {
      window.scrollTo(0, this.scrollTop)
    })
  },
  deactivated () {
    // 组件失活时保存滚动位置
    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
  },
  beforeDestroy () {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    fenToYuanDiscount,
    handleInputSearch () {
      this.debouncedSearch()
    },
    searchList (query) {
      Object.assign(this.query, query)
      // 重置页码和列表
      this.query.pageNum = 1
      this.list = []
      this.noMore = false
      this.getList()
    },
    isOfficial (e) {
      let isOfficial = ''
      if (e.target.checked) {
        isOfficial = '1'
      }
      this.searchList({ isOfficial: isOfficial })
    },
    jump (item) {
      this.$router.push({ path: '/showModule', query: { id: item.pluginId } })
    },
    getList () {
      if (this.loading || this.noMore) return

      this.loading = true
      listReq(this.query).then(res => {
        const { code, data: { list, total }, msg } = res
        if (code !== 0) {
          this.$message.error(msg)
          return []
        }
        // 如果是第一页，直接赋值；否则追加到现有列表
        if (this.query.pageNum === 1) {
          this.list = list
        } else {
          this.list = [...this.list, ...list]
        }
        this.total = total

        // 检查是否还有更多数据
        this.noMore = this.list.length >= total
        return list
      }).finally(() => {
        this.loading = false
      })
    },
    getPlugincate () {
      return getPlugincate().then(res => {
        const { code, data, msg } = res
        if (code !== 0) {
          this.$message.error(msg)
          return []
        }
        return Array.isArray(data) ? data : []
      })
    },
    // 处理滚动事件
    handleScroll () {
      // 获取页面滚动高度
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // 获取页面可视区域高度
      const clientHeight = document.documentElement.clientHeight || window.innerHeight
      // 获取页面总高度
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight

      // 判断是否滚动到底部（距离底部50px时触发）
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.loadMore()
      }
    },
    // 加载更多数据
    loadMore () {
      if (this.loading || this.noMore) return

      this.query.pageNum++
      this.getList()
    }
  }

}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  overflow: hidden;
}
.price{
  .yp{
    text-decoration: line-through;
    color: #999;
    font-size: 14px;
  }
}
.module-head-search {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  margin-top: 60px;
  padding: 30px 0;
  background-color: #3c3f69;
  text-align: center;

  .moduletitle {
    font-size: 36px;
    color: #FFF;
    margin-bottom: 10px;
  }

  .moduledesc {
    font-size: 22px;
    color: #FFF;
    margin-bottom: 20px;
  }

  .modulesearch {
    display: flex;
    justify-content: center;
    padding: 0 15px;

    .search-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      max-width: 600px;
      height: 44px;
      gap: 15px;

      .home-input-wrapper {
        flex: 1;
        min-width: 0;
        height: 100%;
        background: #fff;
        border-radius: 22px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transition: all 0.3s;
        overflow: hidden;

        &:hover,
        &:focus-within {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }

        .home-search-input {
          width: 100%;
          height: 100%;

          /deep/ .el-input__inner {
            height: 100%;
            border: none;
            background: transparent;
          }
        }
      }

      .module-btn {
        width: 100px;
        height: 100%;
        line-height: 44px;
        background: #155bd4;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s;
        user-select: none;
        text-align: center;
        flex-shrink: 0;
        border-radius: 22px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        &:hover {
          background: #1248a5;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }

        &:active {
          background: #0e3d8c;
        }
      }
    }
  }
}

.module-box {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

.clr {
  clear: both;
}

.active {
  color: #155bd4;
}

.search-head {
  cursor: pointer;
}

.mcard {
  cursor: pointer;
}

.module-more {
  width: 100%;
  text-align: center;
  padding: 20px 0;
  clear: both;

  span {
    display: inline-block;
    padding: 10px 30px;
    color: #909399;
    font-size: 14px;
    background-color: #f4f4f5;
    border-radius: 20px;
  }
}

@media screen and (max-width: 768px) {
  .module-head-search {
    margin-top: 0;

    .moduletitle {
      font-size: 24px;
    }

    .moduledesc {
      font-size: 16px;
    }

    .modulesearch {
      .search-wrapper {
        height: 40px;
      }

      .module-btn {
        line-height: 40px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .module-head-search {
    .modulesearch {
      .search-wrapper {
        display: flex;
        flex-direction: column;
        height: auto;
        background: transparent;
        box-shadow: none;
        overflow: visible;

        .home-input-wrapper {
          width: 100%;
          height: 44px;
          border-radius: 22px;
          margin-bottom: 10px;
          margin-right: 0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          background: #fff;
          overflow: hidden;

          .home-search-input {
            width: 100%;
            height: 40px;

            /deep/ .el-input__inner {
              height: 40px;
              border: none;
              background: transparent;
            }
          }
        }

        .module-btn {
          width: 100%;
          height: 44px;
          line-height: 44px;
          border-radius: 22px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}
</style>
